import { useEffect } from 'react';
import { company } from '../content/company';

/** Sets the document title and description for a route. */
export function usePageMeta(title: string, description: string) {
  useEffect(() => {
    document.title = title === company.shortName ? company.legalName : `${title} · ${company.legalName}`;
    document.querySelector('meta[name="description"]')?.setAttribute('content', description);
  }, [title, description]);
}
